import type { PhoneSummary } from '@wml-insta/shared';

interface Props {
  phones: PhoneSummary[];
  /** id активного телефона; null = «Все». */
  activeId: string | null;
  onSelect: (id: string | null) => void;
  /** Показывать вкладку «Все» слева. */
  showAll?: boolean;
}

/**
 * Полоска вкладок телефонов снизу — как листы в гугл-таблице.
 * Один клик переключает телефон вместо возни с фильтром.
 */
export function PhoneTabs({ phones, activeId, onSelect, showAll = true }: Props) {
  return (
    <div className="phone-tabs">
      {showAll && (
        <button
          className={`phone-tab ${activeId == null ? 'active' : ''}`}
          onClick={() => onSelect(null)}
          title="Показать аккаунты всех телефонов"
        >
          Все
        </button>
      )}
      {phones.map((p) => (
        <button
          key={p.id}
          className={`phone-tab ${activeId === p.id ? 'active' : ''}`}
          onClick={() => onSelect(p.id)}
          title={`${p.name} · ${p.accountCount} акк.`}
        >
          {p.name}
        </button>
      ))}
    </div>
  );
}
